/**
 * Helper function to determine if a card should render based on:
 * 1. Feature flag state (isFeatureEnabled)
 * 2. Data presence (hasData)
 *
 * Logic:
 * - If feature flag is OFF → always render (existing behavior)
 * - If feature flag is ON → render only if card has data
 *
 * Note: Cards that should ALWAYS render (Matched Data, Other Data, Tags, Outcome Reasons)
 * simply don't use this helper - they render unconditionally.
 *
 * @param hasData - Whether the card has data to display
 * @param isFeatureEnabled - Whether the 'remove-empty-cards' feature flag is enabled
 * @returns boolean - Whether the card should be rendered
 */
export const shouldRenderCard = (
  hasData: boolean,
  isFeatureEnabled: boolean,
): boolean => {
  // If feature flag is OFF, show all cards (existing behavior)
  if (!isFeatureEnabled) {
    return true;
  }

  // Feature flag is ON, only show if card has data
  return hasData;
};

